import { render, staticRenderFns } from "./note_suggestions.vue?vue&type=template&id=cc2f4d3e"
import script from "./note_suggestions.vue?vue&type=script&lang=js"
export * from "./note_suggestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports